import { Directive, ElementRef, HostListener, OnDestroy, Optional } from '@angular/core';
import { Tooltip } from 'primeng/tooltip';

@Directive({
  selector: '[pTooltip]'
})
export class TouchTooltipDirective implements OnDestroy {
  private readonly isTouchDevice = typeof window !== 'undefined' && (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    window.matchMedia('(hover: none) and (pointer: coarse)').matches
  );
  private readonly documentTouchStartHandler = this.onDocumentTouchStart.bind(this);

  constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    @Optional() private readonly tooltip?: Tooltip,
  ) {
    if (this.isTouchDevice) {
      document.addEventListener('touchstart', this.documentTouchStartHandler, true);
    }
  }

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent): void {
    if (!this.isTouchDevice || !this.tooltip || this.tooltip.disabled) {
      return;
    }

    event.preventDefault();
    this.tooltip.activate();
  }

  private onDocumentTouchStart(event: TouchEvent): void {
    if (!this.isTouchDevice || !this.tooltip || this.tooltip.disabled) {
      return;
    }

    const target = event.target as Node | null;
    if (!target || this.elementRef.nativeElement.contains(target)) {
      return;
    }

    this.tooltip.deactivate();
  }

  ngOnDestroy(): void {
    document.removeEventListener('touchstart', this.documentTouchStartHandler, true);
  }
}
